import './forms.scss';

import angularMessages from 'angular-messages';
import angularMaterial from 'angular-material';

import configModule from '../config/config-module';

import setTitleOnRouteSuccess from './run/set-title-on-route-success';
import getDebounceOptions from './services/get-debounce-options';
import euCode from './filters/eu-code';
import showToast from './services/show-toast';
import showAlert from './services/show-alert';
import responseHandler from './services/response-handler';
import nextDispatcher from './services/next-dispatcher';
import fixPasswordAutofill from './services/fix-password-autofill';
import autofocus from './directives/autofocus';
import noValidate from './directives/no-validate';
import debounceValue from './directives/debounce-value';
import customEmailValidator from './directives/custom-email-validator';
import matchPassword from './validators/match-password';
import emailAvailable from './validators/email-available';
import emailRegistered from './validators/email-registered';
import valuePrefix from './validators/value-prefix';
import errors from './directives/errors';
import formMessage from './directives/form-message';
import genericFormMessages from './directives/generic-form-messages.js';
import passwordFormSubmit from './directives/password-form-submit.js';

export default angular.module('forms', [angularMessages, angularMaterial, configModule])
    .run(setTitleOnRouteSuccess)
    .factory('getOptionsDebounce', getDebounceOptions)
    .filter('euCode', euCode)
    .service('showToast', showToast)
    .service('showAlert', showAlert)
    .service('responseHandler', responseHandler)
    .service('nextDispatcher', nextDispatcher)
    .directive('mdAutofocus', autofocus)
    .directive('mdInputContainer', fixPasswordAutofill)
    .directive('matchPassword', matchPassword)
    .directive('emailAvailable', emailAvailable)
    .directive('emailRegistered', emailRegistered)
    .directive('valuePrefix', valuePrefix)
    .directive('form', noValidate)
    .directive('input', debounceValue)
    .directive('input', customEmailValidator)
    .directive('textarea', debounceValue)
    .directive('errors', errors)
    .directive('formMessage', formMessage)
    .directive('genericFormMessages', genericFormMessages)
    .directive('passwordFormSubmit', passwordFormSubmit)
    .name;



// WEBPACK FOOTER //
// ./forms/forms-module.js